import {iFrameState} from "../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../blink-sdk/Constants";
import {Messages} from "../../../Messages";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {autoredraw} from "../../../../stem-core/decorators/AutoRedraw";
import {BasePanelPage} from "../../PanelPage";


// TODO @flow2 this should be replaced with a generic flow step that throws an error on some conditions
@autoredraw(iFrameState)
export class FunctionalityNotEnabledPanel extends BasePanelPage {
    getMessage() {
        switch (iFrameState.panelType) {
            case PANEL_TYPE.newsletter:
                return Messages.functionalityNotEnabledNewsletters;
            case PANEL_TYPE.giftSubscription:
            case PANEL_TYPE.subscribe:
                return Messages.functionalityNotEnabledSubscriptions;
            case PANEL_TYPE.donation:
                return Messages.functionalityNotEnabledDonations;
            case PANEL_TYPE.shop:
                return Messages.functionalityNotEnabledShop;
            default:
                return Messages.functionalityNotEnabled;
        }
    }

    render() {
        const message = this.getMessage();
        const args = [iFrameMerchantService.getMerchant().name, iFrameState.panelType];
        return <MessageElement message={message} args={args} />;
    }
}
